import Image from "next/image";
import S from "./index.module.scss";
import { FC } from "react";
import { DirectionType } from "@/views/academy/constants/directions";
import { useTranslations } from "next-intl";
import { useMedia } from "@/hooks/system/useMedia";

interface IAcademyDirectionCard {
  card: DirectionType;
}

const AcademyDirectionCard: FC<IAcademyDirectionCard> = ({ card }) => {
  const { isMobile } = useMedia();

  return isMobile ? <AcademyDirectionCardMobile {...card} /> : <AcademyDirectionCardDesktop {...card} />;
};

const AcademyDirectionCardDesktop: FC<DirectionType> = ({ title, image, description }) => {
  const t = useTranslations("academy");

  return (
    <div className={S.wrapper}>
      <div className={S.textWrapper}>
        <span className={S.title}>{t(`${title}`)}</span>
        <span className={S.description}>{t(`${description}`)}</span>
      </div>
      <Image
        className={S.image}
        alt={image}
        src={`/images/academy/directions/${image}.png`}
        width={1400}
        height={650}
      />
    </div>
  );
};

const AcademyDirectionCardMobile: FC<DirectionType> = ({ title, image, description }) => {
  const t = useTranslations("academy");

  return (
    <div className={S.wrapper}>
      <span className={S.title}>{t(`${title}`)}</span>
      <Image
        className={S.image}
        alt={image}
        src={`/images/academy/directions/${image}.png`}
        width={342}
        height={162}
      />
      <span className={S.description}>{t(`${description}`)}</span>
    </div>
  );
};

export default AcademyDirectionCard;
